import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (id) {
  const { rst, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PRODUCTION_INFERIOR',
    url: '',
    method: 'DELETE',
  });

  useEffect(() => {
    if (id) {
      let url = `/api/production/inferior/${id}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [rst, isRequestSuccessed];
});
